import { render, staticRenderFns } from "./upsert.vue?vue&type=template&id=3670ef66&"
import script from "./upsert.vue?vue&type=script&lang=js&"
export * from "./upsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports